export default "__VITE_ASSET__BGGnPzh4__"